import axios from 'axios';
import React, { useEffect, useContext, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import { useParams } from 'react-router-dom';

const Pages = () => {

  const { BaseUrl } = useContext(MyContext);

  const [pagelist, setPageList] = useState([]);
  const [loading, setLoading] = useState(true);

  const Perams = useParams();
  const Title = Perams.title?.replaceAll('-', ' ');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Title]);

  useEffect(() => {
    axios.get(`${BaseUrl}/eapi/e_pagelist.php`)
      .then((res) => {
        // console.log("e_pagelist.php", res.data);
        setPageList(res.data.pagelist);
        setLoading(false);
      })
      .catch((error) => {
        console.error("e_pagelist.php", error);
      })
  }, []);

  return (
    <div className=''>
      {loading
        ? <div className="w-full h-[calc(100vh-90px)] bg-white z-[777] fixed flex items-center justify-center">
          <div className="loader"></div>
        </div>
        : <div className="width_container">
          {
            pagelist?.map((item, index) => {
              if (item.title.toLowerCase() === Title.toLowerCase()) {
                return (
                  <div key={index}>
                    <h3 className='text-[20px] font-[500]'>{item.title}</h3>
                    <p className='p-[20px]' dangerouslySetInnerHTML={{ __html: item?.description }} />
                  </div>
                );
              }
              return null;
            })
          }
        </div>}
    </div>
  )
}

export default Pages